import { useCallback } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { ControlModes } from '@src/types/Stacks';
import {
  generateDefaultFormValues,
  mapFormValuesToControlMode,
} from '../helpers/formHelpers';
import { FormValues } from '../types';

interface UseTemplateFormReturn {
  methods: UseFormReturn<FormValues>;
  onSubmit: (formValues: FormValues) => void;
}

export const useTemplateForm = (
  controlMode: ControlModes,
  handleUpdateStack: (controlMode: ControlModes) => void,
  onSubmitComplete?: () => void,
): UseTemplateFormReturn => {
  const defaultValues = generateDefaultFormValues(controlMode);

  const methods = useForm<FormValues>({
    defaultValues,
    mode: 'onChange',
    resetOptions: {
      keepDirtyValues: false,
    },
  });

  const onSubmit = useCallback(
    (formValues: FormValues) => {
      const updatedControlMode = mapFormValuesToControlMode(
        formValues,
        controlMode,
      );
      handleUpdateStack(updatedControlMode);
      onSubmitComplete?.();
    },
    [controlMode, handleUpdateStack, onSubmitComplete],
  );

  return { methods, onSubmit };
};
